import { Link } from 'react-router-dom';

import { Button } from '@/components/ui/button';
import type { ProductPageContent } from '@/content/products';
import { accentText } from '@/lib/product-accents';
import { cn } from '@/lib/utils';

export function ProductCta({ product }: { product: ProductPageContent }) {
  const { cta } = product;

  return (
    <section
      aria-labelledby={`${product.id}-cta-heading`}
      className="px-4 py-16 sm:px-6 sm:py-20 lg:px-8"
    >
      <div className="border-border/70 bg-card/55 mx-auto w-full max-w-3xl rounded-2xl border px-6 py-10 shadow-sm backdrop-blur-sm sm:px-10 sm:py-12">
        <p className={cn('mb-3 text-xs font-medium tracking-[0.2em] uppercase', accentText[product.accent])}>
          {cta.eyebrow}
        </p>
        <h2
          id={`${product.id}-cta-heading`}
          className="font-display text-foreground text-2xl font-semibold tracking-tight text-balance sm:text-3xl"
        >
          {cta.heading}
        </h2>
        <p className="text-muted-foreground mt-4 text-base leading-relaxed sm:text-lg">{cta.body}</p>

        <div className="mt-8 flex flex-col items-stretch gap-3 sm:flex-row sm:flex-wrap sm:items-center">
          <Button asChild size="lg" variant={cta.primary.variant} className="sm:min-w-48">
            <Link to={cta.primary.href}>{cta.primary.label}</Link>
          </Button>
          <Button asChild size="lg" variant={cta.secondary.variant} className="sm:min-w-48">
            <Link to={cta.secondary.href}>{cta.secondary.label}</Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
